import ComputePipeline from "../../lib/services/compute/computepipeline";
import { YuvFormat } from "../../lib/services/compute/yuvdefs";

export default class LookForStickers3x3Pipeline extends ComputePipeline {
  private device: GPUDevice;
  private layout: GPUBindGroupLayout;
  
  constructor(key: string, shader: GPUShaderModule, device: GPUDevice, threads: number) {
    super(key,threads);
    this.device = device;
   
    const V = GPUShaderStage.COMPUTE;
   
    const entries: GPUBindGroupLayoutEntry[] =  [
          { binding: 0, visibility: V, buffer: { type: "read-only-storage" } },
          { binding: 1, visibility: V, buffer: { type: "storage" } },
          { binding: 2, visibility: V, buffer: { type: "storage" } },
        ];

    this.layout = device.createBindGroupLayout({ entries });
    this.pipeline = device.createComputePipeline({
      layout: device.createPipelineLayout({ bindGroupLayouts: [this.layout] }),
      compute: { module: shader, entryPoint: key },
    });
  }

  build(info_buffer: GPUBuffer, blob2_buffer: GPUBuffer, sticker_buffer: GPUBuffer): void {
    this.bindgroup = this.device.createBindGroup({
      layout: this.layout,
      entries: [
        { binding: 0, resource: { buffer: info_buffer } },
        { binding: 1, resource: { buffer: blob2_buffer } },
        { binding: 2, resource: { buffer: sticker_buffer } },
      ],
    });
  }

  
}